// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format14 } from '../../constants';

/** Cuba */
const CU: PhoneNumberData = [53, 'CU', 8, format14];

export default CU;
